// components/Comments.jsx
import React, { useState } from "react";
import {
  List,
  Card,
  Avatar,
  Input,
  Button,
  Form,
  Space,
  message,
  Divider,
  Modal,
} from "antd";
import { UserOutlined, MessageOutlined } from "@ant-design/icons";
import { useAuth } from "../hooks/useBlogAPI";

const { TextArea } = Input;

const Comments = ({ comments, onSubmit }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleSubmit = async (values) => {
    if (!user) {
      setShowAuthModal(true);
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(values);
      form.resetFields();
      message.success("评论发表成功！");
    } catch (error) {
      message.error("评论发表失败，请重试");
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoToLogin = () => {
    window.location.href = "/auth";
    setShowAuthModal(false);
  };

  const handleCancel = () => {
    setShowAuthModal(false);
  };

  return (
    <>
      <Card title={`评论 (${comments.length})`} bordered={false}>
        <List
          itemLayout="horizontal"
          dataSource={comments}
          renderItem={(comment) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar icon={<UserOutlined />} />}
                title={comment.author}
                description={
                  <div>
                    <div>{new Date(comment.createdAt).toLocaleString()}</div>
                    <div style={{ marginTop: 8 }}>{comment.content}</div>
                  </div>
                }
              />
            </List.Item>
          )}
        />

        <Divider />

        <Form form={form} onFinish={handleSubmit}>
          <Form.Item
            name="content"
            rules={[{ required: true, message: "请输入评论内容" }]}
          >
            <TextArea
              rows={4}
              placeholder={user ? "写下您的评论..." : "登录后才能发表评论"}
              disabled={!user}
            />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={submitting}
                disabled={!user}
              >
                <MessageOutlined /> 发表评论
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* 未登录提示模态框 */}
      <Modal
        title="需要登录"
        open={showAuthModal}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            取消
          </Button>,
          <Button key="login" type="primary" onClick={handleGoToLogin}>
            去登录
          </Button>,
        ]}
      >
        <p>您需要先登录才能发表评论。</p>
      </Modal>
    </>
  );
};

export default Comments;
